import { useState } from 'react';
// @mui
import { Menu, Button, MenuItem, Typography } from '@mui/material';
// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const SORT_BY_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'earliest', label: 'Earliest' },
];

export default function ListSort({  getAllHelpRequests}) {
  const [open, setOpen] = useState(null);
const [sortby,setSortBy]=useState("latest")
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const SortHandler = (value) => {
    console.log("val",value)
    setSortBy(value)
    getAllHelpRequests(value)
   handleClose();
  };

  return (
    <>
      <Button
        color="inherit"
        disableRipple
        onClick={handleOpen}
        endIcon={<Iconify icon={open ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} />}
      >
        Sort By:&nbsp;
        <Typography component="span" variant="subtitle2" sx={{ color: 'text.secondary' }}>
         {sortby}
        </Typography>
      </Button>
      <Menu
        keepMounted
        anchorEl={open}
        open={Boolean(open)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}

      >
        {SORT_BY_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            selected={option.value === sortby}
            onClick={()=>SortHandler(option.value)}
            sx={{ typography: 'body2' }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
